import { render, staticRenderFns } from "./AddGalleryEvent.vue?vue&type=template&id=d6f1e676&scoped=true&"
import script from "./AddGalleryEvent.vue?vue&type=script&lang=js&"
export * from "./AddGalleryEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6f1e676",
  null
  
)

export default component.exports